import { SpaceModel } from "../../interfaces/Space";
import "../../styles/layouts/infodescription.scss"
import parse from 'html-react-parser';

type Props = {
    space: SpaceModel | undefined;
}

export default function InfoDescription({ space }: Props) {

    return <div className="description-container">
        {space?.bio && parse(space.bio)}
    </div>
}